<template>
  <div>
    <vx-card title="Account" class="mb-base">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow"><!-- {{ this.$store.state.userRole }} --></div>

        <feather-icon icon="EditIcon" @click.stop="editAccount" class="hand" />
      </div>
      <div class="vx-row">
        <!-- Information - Col 1 -->
        <div class="vx-col flex-1" id="account-info-col-1">
          <table>
            <tr>
              <td class="font-semibold label-text">Username</td>
              <td>{{ vendorAccModel.userName }}</td>
            </tr>
            <tr>
              <td class="font-semibold label-text">Company Name</td>
              <td>{{ vendorAccModel.companyName }}</td>
            </tr>
            <tr>
              <td class="font-semibold label-text">Status</td>
              <td>
                <vs-chip
                  :color="setStatusColor(vendorAccModel.status)"
                  transparent
                  >{{ vendorAccModel.status }}</vs-chip
                >
              </td>
            </tr>
          </table>
        </div>
        <!-- /Information - Col 1 -->

        <!-- Information - Col 2 -->
        <div class="vx-col flex-1" id="account-info-col-2">
          <table>
            <tr>
              <td class="font-semibold label-text">Approval Status</td>
              <td>
                <vs-chip
                  color="#6AB96F"
                  transparent
                  v-if="vendorAccModel.approvalStatus === 'Approve'"
                  >{{ vendorAccModel.approvalStatus }}</vs-chip
                ><vs-chip
                  color="danger"
                  transparent
                  v-if="vendorAccModel.approvalStatus === 'Reject'"
                  >{{ vendorAccModel.approvalStatus }}</vs-chip
                >
                <vs-chip
                  color="warning"
                  transparent
                  v-if="vendorAccModel.approvalStatus === 'Revise'"
                  >{{ vendorAccModel.approvalStatus }}</vs-chip
                >
                <vs-chip
                  color="warning"
                  transparent
                  v-if="vendorAccModel.approvalStatus === 'WaitingApproval'"
                  >{{ vendorAccModel.approvalStatus }}</vs-chip
                >
              </td>
            </tr>
            <tr>
              <td class="font-semibold label-text">Account Lock</td>
              <td>
                <vs-chip
                  color="danger"
                  transparent
                  v-if="vendorAccModel.isLock === true"
                  >Yes</vs-chip
                >

                <vs-chip
                  color="primary"
                  transparent
                  v-if="vendorAccModel.isLock === false"
                  >No</vs-chip
                >
              </td>
            </tr>
            <tr>
              <td class="font-semibold label-text">Latest Login</td>
              <td>{{ format(vendorAccModel.lastestLogin) }}</td>
            </tr>
          </table>
        </div>
        <!-- /Information - Col 2 -->
        <div class="vx-col w-full flex" id="account-manage-buttons">
          <vs-button
            type="border"
            color="dark"
            icon-pack="feather"
            icon="icon-mail"
            class="mr-4"
            @click="forgotPassword"
            >Resend Password</vs-button
          >
          <vs-button
            type="border"
            color="dark"
            icon-pack="feather"
            icon="icon-unlock"
            @click="unlockAccount"
            >Unlock</vs-button
          >
        </div>
      </div>
    </vx-card>

    <!-- General Information -->
    <v-generalInfo :propVendorID="vendorId"></v-generalInfo>

    <!-- Category -->
    <v-category :propVendorUsername="vendorAccModel.userName"></v-category>

    <!-- Location -->
    <v-location :propVendorUsername="vendorAccModel.userName"></v-location>

    <!-- Contact Information -->
    <!-- <v-contactInfo :propVendorID="vendorId">></v-contactInfo> -->

    <!-- Attachment -->
    <v-attachment :propVendorUsername="vendorAccModel.userName"></v-attachment>

    <v-history></v-history>

    <!-- Action -->
    <vx-card class="mb-base">
      <div class="vx-row flex flex-wrap items-center">
        <div class="vx-col md:w-1/1 sm:w-1/1 w-full font-semibold label-text">
          Comment
        </div>
        <div class="vx-col w-full flex">
          <vs-textarea v-model="comment" />
        </div>
        <div class="vx-col w-full flex">
          <vs-button
            icon-pack="feather"
            icon="icon-check-circle"
            color="success"
            class="mr-4"
            @click="approval('Approve')"
            v-if="IsCanApprove && isAdminVendor"
            >Approve</vs-button
          >
          <vs-button
            icon-pack="feather"
            icon="icon-corner-down-left"
            color="warning"
            class="mr-4"
            @click="approval('Revise')"
            v-if="IsCanApprove && isAdminVendor"
            >Return</vs-button
          >
          <vs-button
            v-if="IsCanApprove && isAdminVendor"
            icon-pack="feather"
            icon="icon-x-circle"
            class="mr-4"
            color="danger"
            @click="approval('Reject')"
            >Reject</vs-button
          >
          <vs-button
            :to="{
              path: '/procurement-management/vendor/list/Active',
            }"
            icon-pack="feather"
            icon="icon-x-circle"
            color="primary"
            class="mr-4"
            >Close</vs-button
          >
        </div>
      </div>
    </vx-card>

    <!--     <vs-popup classContent="popup" title="Account Status" :active.sync="popup">
      <div class="vx-row mb-6">
        <div class="md:w-1/1 sm:w-1/4 w-full ml-4 mr-4">
          <v-select
            class="inputx"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            placeholder="Vendor Status"
            v-model="vendorStatus"
            :options="optionVendorStatus"
          />
        </div>
      </div>
      <vs-divider />
      <div class="vx-row">
        <div class="vx-col md:w-1/1 sm:w-1/2 w-full"></div>
        <div class="vx-col md:w-1/1 sm:w-1/2 w-full">
          <vs-button class="mr-3 mb-2" @click="submit">Submit</vs-button>
          <vs-button type="border" class="mb-2" @click="closePopup"
            >Cancel</vs-button
          >
        </div>
      </div>
    </vs-popup> -->

    <vs-prompt
      class="calendar-event-dialog"
      title="Set Status"
      accept-text="Submit"
      @accept="addEvent"
      :active.sync="activePromptAddEvent"
    >
      <v-select
        class="inputx"
        :dir="$vs.rtl ? 'rtl' : 'ltr'"
        placeholder="Vendor Status"
        v-model="vendorStatus"
        :options="optionVendorStatus"
      />
      <vs-textarea v-model="vendorStatusComment" class="mt-5" />
    </vs-prompt>
  </div>
</template>

<script>
// Services
import { _vendorservice } from "../../services/vendorservices";
import { _userservice } from "../../services/userservices";
import { dateFormat } from "../../services/utility";

// Component
import vSelect from "vue-select";
import generalInfo from "../../components/vendor/GeneralInfo";
import category from "../../components/vendor/Category";
import location from "../../components/vendor/Location";
import contactInfo from "../../components/vendor/ContactInfo";
import attachment from "../../components/vendor/Attachment";
import history from "../../components/vendor/History";

export default {
  components: {
    "v-generalInfo": generalInfo,
    "v-category": category,
    "v-location": location,
    "v-contactInfo": contactInfo,
    "v-attachment": attachment,
    "v-history": history,
    "v-select": vSelect,
  },
  data() {
    return {
      activePromptAddEvent: false,

      vendorId: 0,
      vendorAccModel: {},

      IsCanApprove: false,
      status: "",

      optionVendorStatus: ["Active", "Inactive", "Warning", "Blacklist"],
      vendorStatusComment: "",
      vendorStatus: "",

      isAdminVendor: false,

      comment: "",
    };
  },
  created() {
    this.vendorId = this.$route.params.id;

    // Call function
    this.getVendorAccountById();

    this.getUserRole();
  },
  methods: {
    async getVendorAccountById() {
      this.$vs.loading({
        type: "sound",
      });
      this.vendorAccModel = await _vendorservice.GetVendorAccountById(
        this.vendorId
      );
      this.$vs.loading.close();

      // console.log(this.vendorAccModel);
      // Set Approval Action
      if (
        this.vendorAccModel.approvalStatus != null &&
        this.vendorAccModel.approvalStatus != "Revise"
      )
        this.IsCanApprove = false;
      else this.IsCanApprove = true;
    },
    closePopup() {
      this.popup = false;
    },
    editAccount() {
      /* this.$router
        .push(`/vendor/detail/account/${this.vendorId}`)
        .catch(() => {}); */
      this.activePromptAddEvent = true;
    },
    async approval(status) {
      this.status = status;
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Confirm approval`,
        text: `Are you sure to ${status} this vendor?`,
        accept: this.acceptAlert,
      });
    },
    acceptAlert: async function() {
      const modelApproval = {
        id: parseInt(this.vendorId),
        status: this.status,
        message: this.comment,
      };

      this.$vs.loading({
        type: "sound",
      });

      await _vendorservice.ApprovalVendor(modelApproval);

      this.$vs.loading.close();

      this.$vs.notify({
        title: `Vendor ${this.status}`,
        text: "Success",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success ",
      });

      this.getVendorAccountById();

      // Hide button approve
      this.IsCanApprove = false;
    },
    async getUserRole() {
      var user = await _userservice.GetUserByUserName(
        localStorage.getItem("msal.pkce.access.account")
      );

      // console.log(user);

      this.isAdminVendor = user.isVendorAdmin;
      // this.isAdminVendor = true;
    },
    async forgotPassword() {
      this.$vs.loading({
        type: "sound",
      });

      // console.log(this.vendorAccModel.userName);
      let response = await _vendorservice.ForgotPassword(
        this.vendorAccModel.userName
      );
      // console.log(response);
      if (response) {
        this.$vs.notify({
          title: "Resend password success",
          text: "Success",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success ",
        });

        // Redirect to login page
        // this.$router.push("/pages/login").catch(() => {});
      } else {
        this.$vs.notify({
          title: "Resend password failed",
          text: "Username does not exist",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }

      this.$vs.loading.close();
    },
    async unlockAccount() {
      this.$vs.loading({
        type: "sound",
      });

      // console.log(this.vendorAccModel.userName);
      let response = await _vendorservice.UnlockAccount(this.vendorAccModel.id);
      // console.log(response);
      if (response) {
        this.$vs.notify({
          title: "Unlock account success",
          text: "Success",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success ",
        });

        // Redirect to login page
        // this.$router.push("/pages/login").catch(() => {});
      } else {
        this.$vs.notify({
          title: "Unlock account failed",
          text: "Username does not exist",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }

      this.$vs.loading.close();

      this.getVendorAccountById();
    },
    async addEvent() {
      // console.log(this.vendorStatus);
      this.$vs.loading({
        type: "sound",
      });

      const modelStatus = {
        id: parseInt(this.vendorAccModel.id),
        status: this.vendorStatus,
        comment: this.vendorStatusComment,
      };

      await _vendorservice.SetVendorStatus(modelStatus);

      this.getVendorAccountById();

      this.$vs.notify({
        title: "Set Status",
        text: "Set Status Success",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success",
      });

      this.$vs.loading.close();
    },

    setStatusColor(status) {
      let color = "";
      if (status == "Register") {
        color = "primary";
      }

      if (status == "Active") {
        color = "#6AB96F";
      }

      if (
        status == "Inactive" ||
        status == "Warning" ||
        status == "Blacklist"
      ) {
        color = "danger";
      }

      return color;
    },

    format(date) {
      if (date != null) return dateFormat(date);

      return null;
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}

table {
  td {
    vertical-align: top;
    min-width: 140px;
    padding-bottom: 0.8rem;
    word-break: break-all;
  }

  &:not(.permissions-table) {
    td {
      @media screen and (max-width: 370px) {
        display: block;
      }
    }
  }
}

.hand {
  cursor: pointer;
}

.require-form:after {
  content: "*";
  display: inline;
  color: #900505;
  padding-left: 2px;
}

.label-text {
  padding-bottom: 10px;
  color: #103a5d;
  font-weight: 500;
}
</style>
